import {SettingTypeEnum} from "./setting-type.enum";
import {SettingModuleEnum} from "./setting-module.enum";
import {ValueTypeEnum} from "./value-type.enum";

export class Setting {

  constructor(init?: Partial<Setting>) {
    if (init) {
      for (const key of Object.keys(init)) {
        this[key] = init[key];
      }
    }
  }

  id: string;
  userId: string;
  projectId: string;
  module: SettingModuleEnum;
  settingType: SettingTypeEnum;
  valueType: ValueTypeEnum;
  name: string;
  value: string;
}
